(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbeauty-product-strip"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dsps').forEach((strip) => {
  const track = strip.querySelector('[data-dsps-track]');
  if (!track) return;
  strip.querySelectorAll('[data-dsps-dir]').forEach((button) => {
    button.addEventListener('click', () => {
      track.scrollBy({ left: Number(button.dataset.dspsDir || 1) * track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbeauty-quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-dsq]').forEach((quiz) => {
  const questions = Array.from(quiz.querySelectorAll('[data-dsq-q]'));
  const dots = Array.from(quiz.querySelectorAll('.dsq__dots li'));
  const results = Array.from(quiz.querySelectorAll('[data-dsq-result]'));
  let index = 0;
  let score = { a: 0, b: 0 };
  const show = (i) => {
    questions.forEach((q, n) => { q.hidden = n !== i; q.classList.toggle('is-on', n === i); });
    dots.forEach((d, n) => { d.classList.toggle('is-on', n === i); d.classList.toggle('is-done', n < i); });
  };
  const finish = () => {
    const key = score.b > score.a ? 'b' : 'a';
    questions.forEach((q) => { q.hidden = true; });
    dots.forEach((d) => d.classList.add('is-done'));
    results.forEach((r) => { const on = r.dataset.dsqResult === key; r.hidden = !on; r.classList.toggle('is-in', on); });
    quiz.querySelector('.dsq__stage')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };
  quiz.querySelectorAll('[data-dsq-pick]').forEach((button) => {
    button.addEventListener('click', () => {
      score[button.dataset.dsqPick] += 1;
      index += 1;
      if (index >= questions.length) finish(); else show(index);
    });
  });
  quiz.querySelectorAll('[data-dsq-retake]').forEach((button) => {
    button.addEventListener('click', () => {
      index = 0; score = { a: 0, b: 0 };
      results.forEach((r) => { r.hidden = true; r.classList.remove('is-in'); });
      show(0);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dbeauty-ritual"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dsrt[data-line]').forEach((section) => {
  const pick = (line) => {
    section.dataset.line = line;
    section.querySelectorAll('[data-line-pick]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.linePick === line)));
  };
  section.querySelectorAll('[data-line-pick]').forEach((b) => b.addEventListener('click', () => pick(b.dataset.linePick)));
  const wanted = (new URLSearchParams(window.location.search).get('scent') || '').toLowerCase();
  if (!wanted) return;
  if (wanted === section.dataset.slugB || wanted === 'b') pick('b');
  else if (wanted === section.dataset.slugA || wanted === 'a') pick('a');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
